export default __webpack_public_path__ + "static/media/3.5c51585c.jpg";